<template>
  <div class="entrance-documents">
  <div class="documents__filters">
    <CustomSelect
      :options="this.floors"
      label="Этаж"
      style="width: 150px;"
      optionValueKey="floor"
      optionLabelKey="floor_name"
      :value="this.filters.floor"
      @change="(value) => onChange('floor', value)"
    />
    <CustomSelect
      :options="this.documentTypeSelectOptions"
      label="Тип"
      style="width: 200px;"
      optionValueKey="floor_map_document_type_id"
      optionLabelKey="floor_map_document_type_select_label"
      :value="this.filters.floor_map_document_type_id"
      @change="(value) => onChange('floor_map_document_type_id', value)"
    />
    <CustomCheckbox
      label="Фильтровать по подъезду"
      :value="this.filters.filter_by_entrance"
      @change="(value) => onChange('filter_by_entrance', value)"
    />
    <div
      style="margin-left: auto; display: flex; gap: 10px;"
    >
      <CustomButton
        :loading="downloadingReport"
        @click="downloadOveruseReport"
        color="primary"
        size="sm"
        outline
        style="font-weight: bold;"
      >
        Отчёт Смета vs Списание
      </CustomButton>
      <CustomButton
        @click="openAsrCreatePickCallModal"
        color="primary"
        size="sm"
        outline
        style="font-weight: bold;"
      >
        Создать АСР
      </CustomButton>
      <CustomButton
        @click="openExecListCreatePickCallModal"
        color="primary"
        size="sm"
        outline
        style="font-weight: bold; line-height: 1.2;"
      >
        Создать исполнительную схему
      </CustomButton>
    </div>
  </div>
  <CustomTable
    title="Документы"
    :rowsData="displayedDocuments"
    :columns="tableColumns"
    :stickyHeader="false"
    :loading="isFetching"
    :custom-body="true"
    :custom-header="true"
    :small="true"
  >
    <template v-slot:top-right="props">
      <slot name="top-right">
        <div class="tw-flex tw-items-center tw-gap-2">
          <CustomDropdown
            :loading="this.batchSigning"
            :onClick="(action) => this.handleAction(action.action)"
            :options="this.actionOptions()"
            title="Действия"
            :disable="selectedItems.length === 0"
          />
          <q-btn
            :loading="this.isFetching"
            @click="this.getData"
            color="primary"
            size="sm"
            ><q-icon name="replay"
          /></q-btn>
        </div>
      </slot>
    </template>
    <template #customHeader="props">
      <q-tr>
        <q-th auto-width>
          <q-checkbox
            :model-value="isAllSelected"
            :indeterminate="isIndeterminate"
            @update:model-value="toggleSelectAll"
            :disable="!displayedDocuments.some(item => item.can_sign_doc === true)"
          />
        </q-th>
        <q-th v-for="col in props.cols" :key="col.name" :props="props">
          {{ col.label }}
        </q-th>
      </q-tr>
    </template>
    <template #customBody="props">
      <q-tr>
        <custom-table-cell align="center" vertical-align="center">
          <CustomCheckbox
            v-if="props.row.can_sign_doc === true"
            :value="isItemSelected(props.row)"
            @change="(value) => toggleSelectItem(props.row, value)"
          />
        </custom-table-cell>
        <custom-table-cell align="center" vertical-align="center">
          <div
            style="display: flex; align-items: center; justify-content: center; gap: 4px;"
          >
            {{ props.row.floor_map_document_id }}
            <q-icon
              v-if="props.row.is_manually_created"
              name="edit"
              size="16px"
              color="primary"
              style="cursor: pointer;"
            >
              <q-tooltip>
                Создан вручную<br />
                <span v-if="props.row.manually_fio"
                  >ФИО: {{ props.row.manually_fio }}</span
                >
              </q-tooltip>
            </q-icon>
            <q-icon
              v-if="props.row.is_manual_signed"
              name="upload_file"
              size="16px"
              color="amber-9"
              style="cursor: pointer;"
            >
              <q-tooltip>Подписан на бумаге (загружен скан)</q-tooltip>
            </q-icon>
          </div>
        </custom-table-cell>
        <custom-table-cell align="left" vertical-align="center">
          {{ resolveDocumentTypeDisplayName(props.row) }}
        </custom-table-cell>
        <custom-table-cell align="left" vertical-align="center">
          {{ props.row.work_set_check_group_name }}
        </custom-table-cell>
        <custom-table-cell align="left" vertical-align="center">
          {{ props.row.placement_type_name }}
        </custom-table-cell>
        <custom-table-cell align="center" vertical-align="center">
          {{ props.row.block_name }}
        </custom-table-cell>
        <custom-table-cell align="center" vertical-align="center">
          {{ props.row.floor }}
        </custom-table-cell>
        <custom-table-cell align="center" vertical-align="center">
          <Amount :value="props.row.avr_sum" />
        </custom-table-cell>
        <custom-table-cell align="center" vertical-align="center">
          {{ props.row.date_create }}
        </custom-table-cell>
        <custom-table-cell align="center" vertical-align="center">
          <Clickable
            @click="() => handleDateChange(props.row)"
            >{{ props.row.date_begin }}</Clickable
          >
        </custom-table-cell>
        <custom-table-cell align="center" vertical-align="center">
          <Clickable
            @click="() => handleDateChange(props.row)"
            >{{ props.row.date_end }}</Clickable
          >
        </custom-table-cell>
        <custom-table-cell align="center" vertical-align="center">
          <template v-if="isBuhAccountingAvrRow(props.row)">
            <div class="doc-status-buh">
              <div
                class="doc-status-buh__esf-row"
                :class="{
                  'doc-status-buh__esf-row--with-ico':
                    props.row.is_signed && hasEsfInfo(props.row),
                }"
              >
                <span
                  class="doc-status-buh__esf-k"
                  :class="{
                    'doc-status-buh__esf-k--ok':
                      props.row.is_signed && hasEsfInfo(props.row),
                    'doc-status-buh__esf-k--signed-miss':
                      props.row.is_signed && !hasEsfInfo(props.row),
                  }"
                >{{ esfPrimaryCellLabel(props.row) }}
                  <q-tooltip>{{ esfTooltipText(props.row) }}</q-tooltip>
                </span>
                <q-icon
                  v-if="props.row.is_signed && hasEsfInfo(props.row)"
                  name="check"
                  size="12px"
                  class="doc-status-buh__chk"
                  aria-hidden="true"
                />
              </div>
              <div class="doc-status-buh__divider" aria-hidden="true" />
              <div
                class="doc-status-buh__sign"
                :class="{
                  'doc-status-buh__sign--ok': props.row.is_signed,
                  'doc-status-buh__sign--with-ico': props.row.is_signed,
                }"
              >
                <span class="doc-status-buh__sign-txt">{{
                  props.row.is_signed ? 'Подписано' : 'На подписании'
                }}</span>
                <q-icon
                  v-if="props.row.is_signed"
                  name="check"
                  size="12px"
                  class="doc-status-buh__chk"
                  aria-hidden="true"
                />
              </div>
              <div
                v-if="showK2svProrabChecked(props.row)"
                class="doc-prorab-k2sv tw-mt-2 tw-text-[11px] tw-text-grey-7 tw-leading-snug tw-text-center tw-max-w-[220px] tw-mx-auto"
              >
                <q-icon name="verified" size="12px" class="q-mr-xs tw-align-text-bottom" color="positive" />
                Согласовано прорабом<span v-if="props.row.prorab_k2sv_checked_fio">: {{ props.row.prorab_k2sv_checked_fio }}</span><span v-if="props.row.prorab_k2sv_checked_at">, {{ props.row.prorab_k2sv_checked_at }}</span>
              </div>
            </div>
          </template>
          <template v-else>
            <div
              class="doc-status-plain-wrap"
              :class="{ 'doc-status-plain-wrap--signed': props.row.is_signed }"
            >
              <span
                class="doc-status-plain"
                :class="{ 'doc-status-plain--ok': props.row.is_signed }"
              >{{
                isExecListDocumentRow(props.row)
                  ? execListSignStatusLabel(props.row)
                  : (props.row.is_signed ? 'Подписано' : 'На подписании')
              }}</span>
              <q-icon
                v-if="props.row.is_signed"
                name="check"
                size="12px"
                class="doc-status-buh__chk"
                aria-hidden="true"
              />
            </div>
            <div
              v-if="showK2svProrabChecked(props.row)"
              class="doc-prorab-k2sv tw-mt-2 tw-text-[11px] tw-text-grey-7 tw-leading-snug tw-text-center tw-max-w-[220px] tw-mx-auto"
            >
              <q-icon name="verified" size="12px" class="q-mr-xs tw-align-text-bottom" color="positive" />
              Согласовано прорабом<span v-if="props.row.prorab_k2sv_checked_fio">: {{ props.row.prorab_k2sv_checked_fio }}</span><span v-if="props.row.prorab_k2sv_checked_at">, {{ props.row.prorab_k2sv_checked_at }}</span>
            </div>
          </template>
        </custom-table-cell>
        <custom-table-cell align="center" vertical-align="center">
          <template v-if="!!props.row.assign_signs?.length">
            <Clickable
              v-if="props.row.is_signed && !props.row.is_manual_signed"
              @click="() => this.openSignersModal(props.row)"
            >
              Подписан всеми
            </Clickable>
            <!-- Бумага: показываем слоты (иначе колонка пустая при is_manual_signed) -->
            <div
              v-if="!props.row.is_signed || props.row.is_manual_signed"
              style="display: flex; flex-direction: column; margin: 10px 0; gap: 5px"
            >
              <template
                v-for="(item, i) in props.row.assign_signs"
                :key="item.assign_type_id"
              >
                <div
                  :style="`display: grid; align-items: center; gap: 5px; grid-template-columns: 140px ${item.can_sign && !item.is_signed && !props.row.is_manual_signed ? '55px' : '25px'};`"
                >
                  <div
                    style="display: flex; flex-direction: column; align-items: center; line-height: 14px;"
                  >
                    <div
                      style="display: flex; align-items: center; gap: 5px; flex-wrap: nowrap;"
                    >
                      {{ item.assign_type_name }}
                      <q-icon
                        name="info"
                        style="font-size: 18px; color: #555; cursor: pointer;"
                      >
                        <q-tooltip>
                          <span v-if="!item.employee_fio && !item.phone"
                            >Не найдено</span
                          >
                          <span v-else>
                            {{ item.employee_fio }},
                            {{ this.formatPhoneNumber(item.phone) }}</span
                          >
                        </q-tooltip>
                      </q-icon>
                    </div>
                    <span
                      v-if="item.sign_date"
                      style="font-size: 11px; color: #404040;"
                      >{{ item.sign_date }}</span
                    >
                  </div>
                  <q-btn
                    v-if="item.can_sign && !item.is_signed && !props.row.is_manual_signed"
                    size="xs"
                    padding="xs"
                    @click="signDocument(props.row, item.assign_type_id)"
                    color="primary"
                    :loading="singing[props.row.floor_map_document_id + '_' + item.assign_type_id]"
                    >Подписать</q-btn
                  >
                  <CheckOrClose v-else :value="item.is_signed" />
                </div>
                <hr
                  v-if="i !== props.row.assign_signs?.length - 1"
                  style="width: 100%; border-top: 1px solid #ccc;"
                />
              </template>
            </div>
          </template>
        </custom-table-cell>

        <custom-table-cell align="center" vertical-align="center">
          <div class="doc-download-actions">
            <Clickable
              class="doc-download-actions__download"
              hideUnderline
              :disabled="this.downloadingSigned[props.row.floor_map_document_id] || !!this.downloading[props.row.floor_map_document_id]"
              @click="() => (props.row.have_signed || props.row.is_manual_signed) ? handleDownload(props.row.floor_map_document_id, resolveDocumentTypeDisplayName(props.row), props.row.document_date) : this.handleClickDoc(props.row)"
            >
              <ShinyButton
                v-if="this.downloadingSigned[props.row.floor_map_document_id] || !!this.downloading[props.row.floor_map_document_id]"
                text="Скачать"
              />
              <span v-else>Скачать</span>
              <q-icon name="download" />
            </Clickable>
            <q-btn
              v-if="canUploadBuhAvrManualScan(props.row)"
              outline
              rounded
              no-caps
              color="amber-9"
              size="sm"
              padding="xs sm"
              class="doc-download-actions__followup"
              icon="upload_file"
              label="Скан"
              :loading="!!manualScanUploading[props.row.floor_map_document_id]"
              :disable="!!manualScanUploading[props.row.floor_map_document_id]"
              @click="onUploadBuhAvrManualScan(props.row)"
            >
              <q-tooltip>Загрузить подписанный на бумаге PDF (BUH_AVR)</q-tooltip>
            </q-btn>
            <q-btn
              v-if="isExecListDocumentRow(props.row)"
              outline
              rounded
              no-caps
              color="primary"
              size="sm"
              padding="xs sm"
              class="doc-download-actions__followup"
              icon="autorenew"
              label="Пересформировать"
              :loading="!!execListReformLoading[props.row.floor_map_document_id]"
              :disable="!!execListReformLoading[props.row.floor_map_document_id]"
              @click="onExecListReformClick(props.row)"
            />
            <q-btn
              v-if="isAsrDocumentRow(props.row)"
              outline
              rounded
              no-caps
              color="primary"
              size="sm"
              padding="xs sm"
              class="doc-download-actions__followup"
              icon="autorenew"
              label="Пересобрать АСР"
              @click="onAsrReformClick(props.row)"
            />
            <q-btn
              v-if="props.row.floor_map_document_type_code === 'K2SV' && props.row.can_create_avr_from_k2sv"
              outline
              rounded
              no-caps
              color="primary"
              size="sm"
              padding="xs sm"
              class="doc-download-actions__followup"
              icon="post_add"
              label="АВР и 3КС"
              :aria-label="(props.row.have_signed || props.row.is_signed) ? 'Создать бухгалтерский АВР и акт 3КС на основании подписанного КС2В' : 'Сначала подпишите КС2В, затем создайте АВР и 3КС'"
              :loading="!!creatingK2svFollowup[props.row.floor_map_document_id]"
              :disable="!!creatingK2svFollowup[props.row.floor_map_document_id] || !(props.row.have_signed || props.row.is_signed)"
              @click="createK2svFollowup(props.row)"
            >
              <q-tooltip
                anchor="top middle"
                self="bottom middle"
                :offset="[0, 6]"
                class="bg-grey-9 text-body2"
              >
                <span>{{
                  (props.row.have_signed || props.row.is_signed)
                    ? 'Создать бухгалтерский АВР и акт 3КС по вызовам этого подписанного КС2В.'
                    : 'Сначала подпишите КС2В — затем можно создать бух. АВР и акт 3КС по вызовам этого документа.'
                }}</span>
              </q-tooltip>
            </q-btn>
          </div>
        </custom-table-cell>
        <custom-table-cell align="center" vertical-align="center">
          <p
            v-if="props.row?.is_avr_sent_bi"
            class="tw-flex tw-items-center tw-justify-center tw-text-green-500"
          >
            <CheckOrClose :value="props.row?.is_avr_sent_bi" />Отправлено в 1С
          </p>
          <!-- <CustomButton
            v-else-if="props.row.can_sent_1c"
            size="sm"
            style="height: 30px; width: fit-content; font-size: 11px; white-space: nowrap;"
            :loading="!!this.sending[props.row.floor_map_document_id]"
            @click="() => this.sendTo1C(props.row.floor_map_document_id)"
            >Отправить в 1С</CustomButton
          > -->
          <p
            v-else
            class="tw-flex tw-items-center tw-justify-center tw-text-green-500"
          >
            <CheckOrClose :value="false" />Не отправлено в 1С
          </p>
          <p v-if="!!props.row.guid">GUID: {{ props.row.guid }}</p>
          <div
            v-if="hasEsfInfo(props.row) && !isBuhAccountingAvrRow(props.row)"
            class="doc-1c-esf doc-1c-esf--row"
          >
            <span
              class="doc-1c-esf__k"
              :class="{ 'doc-1c-esf__k--ok': props.row.is_signed }"
            >{{ esfPrimaryCellLabel(props.row) }}
              <q-tooltip>{{ esfTooltipText(props.row) }}</q-tooltip>
            </span>
          </div>
          <p v-if="!!props.row.avr_code">
            Код АВР в 1C: {{ props.row.avr_code }}
          </p>
          <p
            v-if="!!props.row.error"
            class="tw-text-red-700 tw-cursor-pointer tw-mt-2"
          >
            Ошибка
            <q-icon name="info" />
            <q-popup-proxy anchor="top middle" self="bottom middle">
              <q-banner class="tw-p-2 tw-bg-red-100" style="min-height: auto;">
                <span class="tw-text-red-900">{{ props.row.error }}</span>
              </q-banner>
            </q-popup-proxy>
          </p>
        </custom-table-cell>
        <custom-table-cell align="center" vertical-align="center">
          <template v-if="isAsrDocumentRow(props.row)">
            <div
              style="display: flex; flex-direction: column; align-items: center; margin: 10px 0; gap: 5px"
            >
              <CustomButton
                v-if="shouldShowLoadCertificatesButton(props.row)"
                color="primary"
                size="sm"
                outline
                label="Показать сертификаты"
                @click="loadDocumentCertificates(props.row)"
              />
              <q-linear-progress
                v-if="isCertificateLoading(props.row)"
                indeterminate
                style="width: 100%; max-width: 120px;"
              />
              <template v-if="getCertificateUrls(props.row).length">
                <template v-for="(url, i) in getCertificateUrls(props.row)" :key="`${props.row.floor_map_document_id}-${i}`">
                  <Clickable
                    style="display: flex; align-items: center; gap: 5px; justify-content: center;"
                    :link="true"
                    :href="`${this.API_URL}${url}`"
                    target="_blank"
                  >
                    <span>
                      Скачать
                      <span v-if="getCertificateUrls(props.row).length > 1">({{ i + 1 }})</span>
                    </span>
                    <q-icon name="download" />
                  </Clickable>
                </template>
              </template>
              <span
                v-if="isCertificateLoaded(props.row) && !getCertificateUrls(props.row).length"
                class="tw-text-xs tw-text-grey-7"
              >
                Нет сертификатов
              </span>
            </div>
          </template>
        </custom-table-cell>
      </q-tr>
    </template>
  </CustomTable>
  </div>
</template>

<script>

import { useCustomSnackbar } from "@/_helpers/hooks/useCustomSnackbar";
import BackBtn from '@/components/common/BackBtn.vue';
import CheckOrClose from "@/components/common/CheckOrClose";
import Clickable from "@/components/common/Clickable";
import CustomButton from "@/components/common/CustomButton.vue";
import CustomDropdown from "@/components/common/CustomDropdown";
import CustomIcon from "@/components/common/CustomIcon.vue";
import CustomTable from "@/components/common/CustomTable";
import CustomTableCell from "@/components/common/CustomTable/custom-table-cell";
import NotFoundText from "@/components/common/NotFoundText";
import ShinyButton from "@/components/common/ShinyButton";
import CustomCheckbox from "@/components/form/CustomCheckbox";
import CustomSelect from "@/components/form/CustomSelect";
import Amount from "@/components/common/Amount.vue";
import { API_URL, MODAL_NAMES, getAsrCreatePickCallModalTitle, getAsrDocumentTitle } from "@/constants";
import { downloadFile, formatPhoneNumber, isChrome } from "@/services";
import { useAppStore } from "@/services/store/app";
import { mapState } from "pinia";
import {
  canUploadBuhAvrManualScan as canUploadBuhAvrManualScanRow,
  canAccessBuhAvrManualScanUpload,
  getBuhAvrManualScanBlockReason,
  defaultBuhAvrManualSignDate,
} from "@/utils/buhAvrManualScan";
import {
  entranceDocumentColumns,
  getEntranceDocumentFloors,
  getEntranceDocuments,
  getDocumentAsrCertificates,
  getEntranceDocumentTypes,
  getExecListScreedPlacementRows,
  resolveFloorMapDocumentDisplayName,
  sendDocumentAvrTo1C,
  signEntranceDocument,
  signM19OverDocument,
  batchCreateDocuments,
  downloadMaterialOveruseReport,
  createFollowupFromK2sv,
  uploadBuhAvrManualSign,
  getFloorWorkSets,
} from "./services";
import {
  buildExecListModalRowsFromScreedPlacementRows,
  pickWorkSetsFromFloorInfo,
} from "@/views/EmployeeTasks/services";

/** Старый тип по коду в БД `M19`; в справочнике приходит только имя — совпадение по отображаемому названию. */
function isLegacyM19DocumentTypeName(name) {
  const n = (name || "").trim();
  return n === "M19" || n === "М19";
}

/** Заглушка из `floor_map_document__read` при `esf_state = 1` и пустом `esf_status`. */
const ESF_PLACEHOLDER_RU = "Принят от поставщика";

function esfStatusText(row) {
  const s = row?.esf_status;
  if (s == null || typeof s !== "string") return s ? String(s).trim() : "";
  return s.trim();
}

function hasEsfInfo(row) {
  const t = esfStatusText(row);
  if (t === ESF_PLACEHOLDER_RU) return true;
  if (t.length > 0) return true;
  if (Number(row?.esf_state) === 1) return true;
  return false;
}

function esfPrimaryCellLabel(row) {
  if (!row?.is_signed) return "ЭСФ";
  if (hasEsfInfo(row)) return "ЭСФ";
  return "Нет ЭСФ";
}

function esfTooltipText(row) {
  if (!hasEsfInfo(row)) return "Нет данных по ЭСФ";
  const t = esfStatusText(row);
  if (t === ESF_PLACEHOLDER_RU) return "ЭСФ: принят от поставщика";
  if (t) return `ЭСФ: ${t}`;
  if (Number(row?.esf_state) === 1) return "ЭСФ: принят от поставщика";
  return "ЭСФ";
}

function isExecListDocumentRow(row) {
  return row?.floor_map_document_type_code === "EXEC_LIST";
}

function execListSignStatusLabel(row) {
  if (!row?.is_signed) return "На подписании";
  if (row?.is_manual_signed) return "Подписано (бумага)";
  return "Подписано";
}

function isAsrDocumentRow(row) {
  return row?.floor_map_document_type_code === "ASR";
}

/** Уже есть хотя бы одна подпись по цепочке подписантов (или полностью подписан). */
function hasExecListSignerSigned(row) {
  if (!row) return false;
  if (row.have_signed) return true;
  if (Array.isArray(row.assign_signs) && row.assign_signs.some((s) => s?.is_signed)) return true;
  return false;
}

function resolveExecListFloorMapId(doc, floors) {
  if (doc?.floor_map_id != null) return doc.floor_map_id;
  const raw = String(doc?.floor ?? "").split(",")[0].trim();
  if (!raw) return null;
  const n = Number(raw);
  const match = (floors || []).find((f) => Number(f.floor) === n);
  return match?.floor_map_id ?? null;
}

/** Плоские строки exec_list_work_sets_for_floor_map + метаданные документа в таблице. */
function resolveExecListWorkSetCheckGroupIdFromScreedRows(rows, doc) {
  if (doc?.work_set_check_group_id != null) return doc.work_set_check_group_id;
  const dGroup = String(doc?.work_set_check_group_name ?? "").trim();
  if (!dGroup || !Array.isArray(rows)) return null;
  for (const r of rows) {
    const name = String(r.work_set_check_group_name ?? "").trim();
    if (name && dGroup.includes(name)) return r.work_set_check_group_id;
  }
  return null;
}

const FILTER_BY_ENTRANCE_STORAGE_KEY = 'entranceDocuments_filter_by_entrance';
const DOCUMENT_TYPE_FILTER_STORAGE_KEY = 'entranceDocuments_floor_map_document_type_id';

function readSavedDocumentTypeId() {
  if (typeof window === 'undefined' || !window.localStorage) return '';
  const raw = window.localStorage.getItem(DOCUMENT_TYPE_FILTER_STORAGE_KEY);
  if (raw == null || raw === '') return '';
  const n = Number(raw);
  return Number.isNaN(n) ? '' : n;
}

function saveDocumentTypeFilter(value) {
  if (typeof window === 'undefined' || !window.localStorage) return;
  if (value == null || value === '') {
    window.localStorage.removeItem(DOCUMENT_TYPE_FILTER_STORAGE_KEY);
  } else {
    window.localStorage.setItem(DOCUMENT_TYPE_FILTER_STORAGE_KEY, String(value));
  }
}

function readSavedFilterByEntrance() {
  if (typeof window === 'undefined' || !window.localStorage) return false;
  const raw = window.localStorage.getItem(FILTER_BY_ENTRANCE_STORAGE_KEY);
  if (raw === null) return false;
  return raw === 'true' || raw === '1';
}

function saveFilterByEntrance(value) {
  if (typeof window === 'undefined' || !window.localStorage) return;
  window.localStorage.setItem(FILTER_BY_ENTRANCE_STORAGE_KEY, value ? '1' : '0');
}

function resolveExecListPlacementAndGroupFromScreedRows(rows, doc, workSetCheckGroupId) {
  if (doc?.placement_type_id != null && doc?.work_set_check_group_id != null) {
    return {
      placementTypeId: doc.placement_type_id,
      workSetCheckGroupId: doc.work_set_check_group_id,
    };
  }
  if (workSetCheckGroupId == null || !Array.isArray(rows)) return null;
  const filtered = rows.filter(
    (r) => Number(r.work_set_check_group_id) === Number(workSetCheckGroupId)
  );
  if (!filtered.length) return null;
  const dPlacement = String(doc?.placement_type_name ?? "").trim();
  const dGroup = String(doc?.work_set_check_group_name ?? "").trim();
  for (const r of filtered) {
    const leg = String(r.legend_placement_type_name ?? "").trim();
    const setn = String(r.setting_placement_type_name ?? "").trim();
    const gname = String(r.work_set_check_group_name ?? "").trim();
    if (dGroup && gname && !dGroup.includes(gname)) continue;
    if (!dPlacement) {
      return { placementTypeId: r.setting_placement_type_id, workSetCheckGroupId };
    }
    if (leg && dPlacement.includes(leg)) {
      return { placementTypeId: r.setting_placement_type_id, workSetCheckGroupId };
    }
    if (setn && dPlacement.includes(setn)) {
      return { placementTypeId: r.setting_placement_type_id, workSetCheckGroupId };
    }
  }
  return {
    placementTypeId: filtered[0].setting_placement_type_id,
    workSetCheckGroupId,
  };
}

export default {
  name: "EntranceDocuments",
  props: {
    params: { type: Object, default: () => ({}) },
    initialFloorMapDocumentTypeId: { type: [Number, String], default: null },
    activeData: { type: Object, default: {contractor_id: null, resident_id: null} },
  },
  components: {
    CustomTable,
    CustomTableCell,
    CustomCheckbox,
    CheckOrClose,
    NotFoundText,
    CustomDropdown,
    Clickable,
    BackBtn,
    CustomIcon,
    CustomSelect,
    ShinyButton,
    CustomButton,
    Amount,
  },
  data() {
    return {
      API_URL,
      data: [],
      floors: [],
      documentTypes: [],
      loading: false,
      filters: {
        floor: '',
        floor_map_document_type_id: readSavedDocumentTypeId(),
        filter_by_entrance: readSavedFilterByEntrance(),
      },
      downloading: {},
      sending: {},
      downloadingSigned: {},
      isFetching: false,
      singing: {},
      selectedItems: [],
      batchSigning: false,
      downloadingReport: false,
      creatingK2svFollowup: {},
      execListReformLoading: {},
      manualScanUploading: {},
      certificateUrlsByDocId: {},
      certificateLoadingByDocId: {},
      certificateLoadedByDocId: {},
      documentsFetchController: null,
      documentsFetchSeq: 0,
      tableColumns: entranceDocumentColumns,
    };
  },
  watch: {
    data() {
      this.syncSelectedWithDisplayed();
    },
    displayedDocuments() {
      this.syncSelectedWithDisplayed();
    },
  },
  computed: {
    ...mapState(useAppStore, ["userData"]),
    canAccessBuhAvrManualScanUpload() {
      return canAccessBuhAvrManualScanUpload(this.userData?.employee_id);
    },
    displayedDocuments() {
      return this.data;
    },
    isAllSelected() {
      const selectableItems = this.displayedDocuments.filter(
        (item) => item.can_sign_doc === true
      );
      if (selectableItems.length === 0) return false;
      return selectableItems.every((item) =>
        this.selectedItems.includes(item.floor_map_document_id)
      );
    },
    isIndeterminate() {
      const selectableItems = this.displayedDocuments.filter(
        (item) => item.can_sign_doc === true
      );
      if (selectableItems.length === 0) return false;
      const selectedCount = selectableItems.filter((item) =>
        this.selectedItems.includes(item.floor_map_document_id)
      ).length;
      return selectedCount > 0 && selectedCount < selectableItems.length;
    },
    documentTypeSelectOptions() {
      return (this.documentTypes || []).map((t) => {
        const name = t.floor_map_document_type_name;
        const floor_map_document_type_select_label = isLegacyM19DocumentTypeName(name)
          ? `${name} (Старый)`
          : name ?? "";
        return { ...t, floor_map_document_type_select_label };
      });
    },
  },
  methods: {
    /** Бухгалтерский АВР 3-2 — код `BUH_AVR`; строка ЭСФ в «Статусе» только для этого типа. */
    isBuhAccountingAvrRow(row) {
      return row?.floor_map_document_type_code === 'BUH_AVR';
    },
    /** Кнопка загрузки бумажного скана BUH_AVR (с проверками + только employee_id=2277). */
    canUploadBuhAvrManualScan(row) {
      if (!this.canAccessBuhAvrManualScanUpload) return false;
      return this.isBuhAccountingAvrRow(row) && canUploadBuhAvrManualScanRow(row);
    },
    buhAvrManualScanBlockReason(row) {
      if (!this.isBuhAccountingAvrRow(row)) return null;
      return getBuhAvrManualScanBlockReason(row);
    },
    onUploadBuhAvrManualScan(row) {
      if (!this.canUploadBuhAvrManualScan(row)) {
        const reason = this.buhAvrManualScanBlockReason(row);
        if (reason) this.showErrorSnackbar(reason);
        return;
      }
      const id = row.floor_map_document_id;
      this.showModal(MODAL_NAMES.BuhAvrManualScan, {
        title: "Загрузить бумажный скан АВР",
        row,
        defaultDate: defaultBuhAvrManualSignDate(row),
        onConfirm: async ({ signDate, file }) => {
          this.manualScanUploading = { ...this.manualScanUploading, [id]: true };
          try {
            await uploadBuhAvrManualSign({
              floor_map_document_id: id,
              file,
              sign_date: String(signDate).trim(),
              params: { ...this.params },
            });
            this.showSucceedSnackbar("Бумажный скан загружен, подписанты проставлены");
            await this.getData();
          } catch (e) {
            this.showErrorSnackbar(
              e?.response?.data?.message
                || e?.response?.data?.error
                || e?.message
                || "Не удалось загрузить скан",
            );
            throw e;
          } finally {
            this.manualScanUploading = { ...this.manualScanUploading, [id]: false };
          }
        },
      });
    },
    hasEsfInfo,
    esfPrimaryCellLabel,
    esfTooltipText,
    isExecListDocumentRow,
    execListSignStatusLabel,
    isAsrDocumentRow,
    getCertificateUrls(row) {
      const id = row?.floor_map_document_id;
      if (id != null && Object.prototype.hasOwnProperty.call(this.certificateUrlsByDocId, id)) {
        return this.certificateUrlsByDocId[id] || [];
      }
      const fromRow = row?.certificate_urls;
      return Array.isArray(fromRow) ? fromRow.filter((url) => url) : [];
    },
    shouldShowLoadCertificatesButton(row) {
      if (!this.isAsrDocumentRow(row)) return false;
      if (this.isCertificateLoading(row)) return false;
      if (this.getCertificateUrls(row).length > 0) return false;
      if (this.isCertificateLoaded(row)) return false;
      return true;
    },
    isCertificateLoading(row) {
      return !!this.certificateLoadingByDocId[row?.floor_map_document_id];
    },
    isCertificateLoaded(row) {
      return !!this.certificateLoadedByDocId[row?.floor_map_document_id];
    },
    async loadDocumentCertificates(row) {
      const id = row?.floor_map_document_id;
      if (!id || this.isCertificateLoading(row)) return;
      this.certificateLoadingByDocId = { ...this.certificateLoadingByDocId, [id]: true };
      const urls = await getDocumentAsrCertificates(id);
      this.certificateLoadingByDocId = { ...this.certificateLoadingByDocId, [id]: false };
      if (urls === null) return;
      this.certificateUrlsByDocId = { ...this.certificateUrlsByDocId, [id]: urls };
      this.certificateLoadedByDocId = { ...this.certificateLoadedByDocId, [id]: true };
    },
    syncSelectedWithDisplayed() {
      this.selectedItems = this.selectedItems.filter((id) =>
        this.displayedDocuments.some(
          (item) => item.floor_map_document_id === id
        )
      );
    },
    // Опции для выпадающего меню действий
    actionOptions() {
      return [
        {
          action: 'batch_sign',
          label: 'Массовая подпись',
          disable: this.selectedItems.length === 0 || this.selectedItems.length > 10,
        },
      ];
    },
    formatPhoneNumber,
    // Выбрать/снять выбор всех документов с can_sign_doc = true
    toggleSelectAll(value) {
      const selectableItems = this.displayedDocuments.filter(
        (item) => item.can_sign_doc === true
      );
      if (value) {
        const selectableIds = selectableItems.map(
          (item) => item.floor_map_document_id
        );
        this.selectedItems = [...new Set([...this.selectedItems, ...selectableIds])];
      } else {
        this.selectedItems = this.selectedItems.filter(
          (id) =>
            !selectableItems.some((item) => item.floor_map_document_id === id)
        );
      }
    },
    // Выбрать/снять выбор отдельного документа
    toggleSelectItem(item, value) {
      if (!item.can_sign_doc) return;
      const index = this.selectedItems.indexOf(item.floor_map_document_id);
      if (value) {
        if (index === -1) {
          this.selectedItems.push(item.floor_map_document_id);
        }
      } else {
        if (index > -1) {
          this.selectedItems.splice(index, 1);
        }
      }
    },
    // Проверяет, выбран ли документ
    isItemSelected(item) {
      return this.selectedItems.includes(item.floor_map_document_id);
    },
    cancelDocumentsFetch() {
      if (this.documentsFetchController) {
        this.documentsFetchController.abort();
        this.documentsFetchController = null;
      }
    },
    async getData() {
      this.cancelDocumentsFetch();
      const controller = new AbortController();
      this.documentsFetchController = controller;
      const fetchSeq = ++this.documentsFetchSeq;

      this.isFetching = true;
      const res = await getEntranceDocuments(
        { ...this.filters, ...this.params },
        controller.signal
      );

      if (fetchSeq !== this.documentsFetchSeq) return;

      this.isFetching = false;
      this.documentsFetchController = null;
      if (!res) return;
      this.data = res;
      this.certificateUrlsByDocId = {};
      this.certificateLoadingByDocId = {};
      this.certificateLoadedByDocId = {};
    },
    onChange(key, value) {
      this.filters[key] = value;
      if (key === 'filter_by_entrance') {
        saveFilterByEntrance(value);
      }
      if (key === 'floor_map_document_type_id') {
        saveDocumentTypeFilter(value);
      }
      this.getData();
    },
    syncDocumentTypeFilterWithLoadedTypes() {
      const tid = this.filters.floor_map_document_type_id;
      if (tid === '' || tid == null) return;
      const ok = (this.documentTypes || []).some(
        (t) => String(t.floor_map_document_type_id) === String(tid)
      );
      if (!ok) {
        this.filters.floor_map_document_type_id = '';
        saveDocumentTypeFilter('');
      }
    },
    async getDocumentTypes() {
      const res = await getEntranceDocumentTypes();
      this.documentTypes = res || [];
    },
    async getDocumentFloors() {
      const res = await getEntranceDocumentFloors(this.params);
      this.floors = res || [];
    },
    showK2svProrabChecked(row) {
      if (row?.floor_map_document_type_code !== 'K2SV') return false
      return !!(row?.prorab_k2sv_checked_fio || row?.prorab_k2sv_checked_at)
    },
    resolveDocumentTypeDisplayName(row) {
      return resolveFloorMapDocumentDisplayName(row, {
        projectTypeCode: this.activeData?.project_type_code,
        projectTypeId: this.params?.project_type_id,
      });
    },
    async handleClickDoc(doc) {
      const id = doc.floor_map_document_id
      if (this.downloading[id]) return
      this.downloading = { ...this.downloading, [id]: true }
      try {
        const displayName = this.resolveDocumentTypeDisplayName(doc)
        await downloadFile(doc.master_url, `${displayName}${doc.document_date ? ` - ${doc.document_date}` : ''}`, { ...this.params }, doc.file_ext || 'pdf', 'get', false)
      } finally {
        const { [id]: _r, ...rest } = this.downloading
        this.downloading = rest
      }
    },
    handleDateChange(doc) {
      this.showModal(MODAL_NAMES.ChangeEntranceDocument, {
        title: 'Изменить даты',
        body: doc,
        data: {
          floor_map_document_id: doc.floor_map_document_id,
        }, params: this.params,
        onSubmit: (res) => {
          if (!res) return;
          this.data = res;
        },
      })
    },
    openSignersModal(data) {
      this.showModal(MODAL_NAMES.ProjectDocumentSigners, {
        title: `Подписанты: ${data.floor_map_document_type_name}`,
        data: data.assign_signs,
      })
    },
    async sendTo1C(floor_map_document_id) {
      if (this.sending[floor_map_document_id]) return
      this.sending[floor_map_document_id] = true
      const res = await sendDocumentAvrTo1C(floor_map_document_id, { ...this.params, ...this.filters });
      this.sending[floor_map_document_id] = false
      if (!res) {
        this.getData();
        return
      }
      this.data = res;
      this.showSucceedSnackbar()
    },
    async handleDownload(floor_map_document_id, floor_map_document_type_name, document_date) {
      if (this.downloadingSigned[floor_map_document_id]) return
      const url = `${API_URL}/project/documents/signed/download/`
      const fileName = floor_map_document_type_name ? `${floor_map_document_type_name}${document_date ? ` - ${document_date}` : ''}` : 'Подписанный документ.pdf'
      this.downloadingSigned[floor_map_document_id] = true
      await downloadFile(url, fileName, { floor_map_document_id, ...this.params }, 'pdf', 'post', false, { params: { ...this.params } })
      this.downloadingSigned[floor_map_document_id] = false
    },
    async signDocument(doc, assign_type_id) {
      const floor_map_document_id = doc.floor_map_document_id;
      const isM19Over = doc.floor_map_document_type_code === 'M19_OVER';
      const body = { floor_map_document_id };
      const key = floor_map_document_id + '_' + assign_type_id;

      this.singing[key] = true;
      const res = isM19Over
        ? await signM19OverDocument(body, this.params)
        : await signEntranceDocument(body, this.params);
      this.singing[key] = false;

      if (!res) return;

      if (isChrome())
        return window.open(res?.redirect_url);
      window.location.href = res?.redirect_url;
    },
    async handleAction(action) {
      if (action === 'batch_sign') {
        await this.handleBatchSign();
      }
    },
    async handleBatchSign() {
      if (this.selectedItems.length === 0) {
        this.showErrorSnackbar("Не выбрано ни одного документа");
        return;
      }
      if (this.selectedItems.length > 10) {
        this.showErrorSnackbar("Максимальное количество документов для подписания - 10");
        return;
      }

      this.batchSigning = true;
      try {
        const signUrl = await batchCreateDocuments(this.selectedItems, this.params);
        if (!signUrl) {
          this.batchSigning = false;
          this.showErrorSnackbar("Не получен URL для подписания");
          return;
        }

        // Очищаем выбранные элементы после успешного создания
        this.selectedItems = [];

        // Переходим по URL для подписания
        if (isChrome()) {
          window.open(signUrl);
        } else {
          window.location.href = signUrl;
        }
      } catch (e) {
        this.batchSigning = false;
        this.showErrorSnackbar(e?.response?.data?.message || e?.message || "Ошибка при создании массовой подписи");
      }
    },
    async downloadOveruseReport() {
      const projectId = this.params?.project_id;
      if (!projectId) {
        this.showErrorSnackbar("Не указан ID проекта");
        return;
      }
      this.downloadingReport = true;
      const res = await downloadMaterialOveruseReport(projectId);
      this.downloadingReport = false;
      if (!res) return;
      if (!res.success) {
        this.showErrorSnackbar(res.message);
        return;
      }
      this.showSucceedSnackbar();
    },
    async createK2svFollowup(doc) {
      const floor_map_document_id = doc.floor_map_document_id;
      if (!floor_map_document_id || this.creatingK2svFollowup[floor_map_document_id]) return;
      if (!(doc.have_signed || doc.is_signed)) {
        this.showErrorSnackbar("Сначала подпишите КС2В");
        return;
      }
      this.creatingK2svFollowup = {
        ...this.creatingK2svFollowup,
        [floor_map_document_id]: true,
      };
      try {
        await createFollowupFromK2sv(floor_map_document_id);
        this.showSucceedSnackbar("Документы бух. АВР и 3КС созданы");
        await this.getData();
      } catch (e) {
        this.showErrorSnackbar(
          e?.response?.data?.error ||
            e?.response?.data?.message ||
            e?.message ||
            "Ошибка при создании документов"
        );
      } finally {
        const { [floor_map_document_id]: _removed, ...rest } = this.creatingK2svFollowup;
        this.creatingK2svFollowup = rest;
      }
    },
    onExecListReformClick(doc) {
      if (!isExecListDocumentRow(doc)) return;
      if (hasExecListSignerSigned(doc)) {
        this.showModal(MODAL_NAMES.CONFIRM, {
          title: "Пересформировать исполнительную схему",
          message:
            "По этому документу уже есть подписанты. После пересборки документ нужно будет подписать заново. Продолжить?",
          btnText: "Пересформировать",
          cancelBtnText: "Отмена",
          onSubmit: async () => {
            this.closeModal();
            await this.openExecListReformModal(doc);
          },
        });
        return;
      }
      this.openExecListReformModal(doc);
    },
    async openExecListReformModal(doc) {
      const floorMapDocumentId = doc?.floor_map_document_id;
      const projectId = this.params?.project_id;
      if (!floorMapDocumentId || !projectId) {
        this.showErrorSnackbar("Не хватает данных для пересборки документа");
        return;
      }
      if (this.execListReformLoading[floorMapDocumentId]) return;
      this.execListReformLoading = {
        ...this.execListReformLoading,
        [floorMapDocumentId]: true,
      };
      const clearReformLoading = () => {
        const { [floorMapDocumentId]: _removed, ...rest } = this.execListReformLoading;
        this.execListReformLoading = rest;
      };
      const floorMapId = resolveExecListFloorMapId(doc, this.floors);
      if (!floorMapId) {
        clearReformLoading();
        this.showErrorSnackbar("Не удалось определить этаж для документа");
        return;
      }

      const isProjectDirty = this.activeData.project_type_code === 'PROJECT_DIRTY';
      let placementRows = isProjectDirty 
                              ? await getFloorWorkSets(floorMapId, {placement_type_id: doc.placement_type_id || null, work_set_check_group_id: doc.work_set_check_group_id || null})
                              : await getExecListScreedPlacementRows(floorMapId, {work_set_check_group_id: doc.work_set_check_group_id || null});
      if (!placementRows) {
        clearReformLoading();
        this.showErrorSnackbar("Не удалось загрузить работы по этажу");
        return;
      }
      let modalRows = [];
      let placementTypeId = null;
      let workSetCheckGroupId = null;
      if (isProjectDirty) {
        workSetCheckGroupId = doc.work_set_check_group_id || null;
        placementTypeId = doc.placement_type_id || null;
        modalRows = pickWorkSetsFromFloorInfo(placementRows, doc.placement_type_id || null, doc.work_set_check_group_id || null);
      } else {
        workSetCheckGroupId = resolveExecListWorkSetCheckGroupIdFromScreedRows(placementRows, doc);
        if (workSetCheckGroupId == null) {
          clearReformLoading();
          this.showErrorSnackbar("Не удалось определить группу работ документа");
          return;
        }
        const ids = resolveExecListPlacementAndGroupFromScreedRows(placementRows, doc, workSetCheckGroupId);
        placementTypeId = ids?.placementTypeId ?? null;
        modalRows = buildExecListModalRowsFromScreedPlacementRows(placementRows, workSetCheckGroupId);
        if (!modalRows.length) {
          clearReformLoading();
          this.showErrorSnackbar("Нет работ в группе для исполнительной схемы");
          return;
        }
      }

      clearReformLoading();
      this.showModal(MODAL_NAMES.ExecListCreateDocument, {
        title: "Исполнительная схема: пересборка",
        projectId,
        floorMapId,
        placementTypeId,
        workSetCheckGroupId,
        rows: modalRows.map((s) => ({
          placement_type_id: s.placement_type_id,
          legend_placement_type_id: s.legend_placement_type_id,
          placement_type_name: s.placement_type_name,
          work_set_id: s.work_set_id,
          work_set_name: s.work_set_name,
          unit_name: s.unit_name,
          work_set_amount: s.work_set_amount,
        })),
        documentParams: { ...this.params },
        generateOnly: true,
        reformFloorMapDocumentId: doc.floor_map_document_id,
        openConfirmModal: (payload) => this.showModal(MODAL_NAMES.CONFIRM, payload),
        onSuccess: () => {
          this.getData();
        },
      });
    },
    openAsrCreatePickCallModal() {
      const projectId = this.params?.project_id;
      if (!projectId) {
        this.showErrorSnackbar("Не указан ID проекта");
        return;
      }
      this.showModal(MODAL_NAMES.AsrCreatePickCall, {
        title: getAsrCreatePickCallModalTitle(
          this.activeData?.project_type_code,
          this.params?.project_type_id
        ),
        projectId,
        contractorId: this.activeData?.contractor_id,
        residentId: this.activeData?.resident_id,
        projectEntranceId: this.params?.project_entrance_id,
        projectTypeCode: this.activeData?.project_type_code,
        projectTypeId: this.params?.project_type_id,
        documentParams: { ...this.params },
        floorOptions: Array.isArray(this.floors) ? [...this.floors] : [],
        onSuccess: () => {
          this.getData();
        },
      });
    },
    openExecListCreatePickCallModal() {
      const projectId = this.params?.project_id;
      if (!projectId) {
        this.showErrorSnackbar("Не указан ID проекта");
        return;
      }
      this.showModal(MODAL_NAMES.ExecListCreatePickCall, {
        title: "Создать исполнительную схему",
        projectId,
        projectEntranceId: this.params?.project_entrance_id,
        projectTypeCode: this.activeData?.project_type_code,
        documentParams: { ...this.params },
        floorOptions: Array.isArray(this.floors) ? [...this.floors] : [],
        onSuccess: () => {
          this.getData();
        },
      });
    },
    onAsrReformClick(doc) {
      if (!isAsrDocumentRow(doc)) return;
      const startReform = () => this.openAsrReformModal(doc);
      if (doc?.have_signed) {
        const asrTitle = getAsrDocumentTitle(
          this.activeData?.project_type_code,
          this.params?.project_type_id
        );
        this.showModal(MODAL_NAMES.CONFIRM, {
          title: `Пересобрать ${asrTitle.charAt(0).toLowerCase()}${asrTitle.slice(1)}`,
          message:
            "По этому документу уже есть подписанты. После пересборки документ нужно будет подписать заново. Продолжить?",
          btnText: "Пересобрать",
          cancelBtnText: "Отмена",
          onSubmit: () => {
            this.closeModal();
            startReform();
          },
        });
        return;
      }
      startReform();
    },
    openAsrReformModal(doc) {
      const asrTitle = getAsrDocumentTitle(
        this.activeData?.project_type_code,
        this.params?.project_type_id
      );
      this.showModal(MODAL_NAMES.AsrCreateOrReform, {
        title: `${asrTitle}: пересборка`,
        mode: "reform",
        reformFloorMapDocumentId: doc.floor_map_document_id,
        residentId: this.activeData?.resident_id,
        contractorId: this.activeData?.contractor_id,
        residentName: doc.resident_name,
        contractorName: doc.contractor_name,
        projectName: doc.project_name,
        documentParams: { ...this.params },
        onSuccess: () => {
          this.getData();
        },
      });
    },
  },
  setup() {
    const { showModal, closeModal } = useAppStore();
    const { showSucceedSnackbar, showErrorSnackbar } = useCustomSnackbar();
    return { showSucceedSnackbar, showErrorSnackbar, showModal, closeModal };
  },
  async mounted() {
    if (this.initialFloorMapDocumentTypeId != null && this.initialFloorMapDocumentTypeId !== '') {
      this.filters.floor_map_document_type_id = this.initialFloorMapDocumentTypeId;
      saveDocumentTypeFilter(this.initialFloorMapDocumentTypeId);
    }
    await Promise.all([
      this.getData(),
      this.getDocumentFloors(),
      this.getDocumentTypes(),
    ]);
    const typeIdBeforeSync = this.filters.floor_map_document_type_id;
    this.syncDocumentTypeFilterWithLoadedTypes();
    if (String(typeIdBeforeSync ?? '') !== String(this.filters.floor_map_document_type_id ?? '')) {
      await this.getData();
    }
  },
  beforeUnmount() {
    this.cancelDocumentsFetch();
  },
};
</script>

<style scoped lang="scss">
.documents__filters {
  margin-bottom: 15px;
  display: flex;
  gap: 20px;
  align-items: flex-end;
  flex-wrap: wrap;
}

/* Колонка «Статус»: ЭСФ + подпись только для бух. АВР (BUH_AVR) */
.doc-status-buh {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  max-width: 12rem;
  margin: 0 auto;
  line-height: 1.25;
}
.doc-status-buh__esf-row {
  width: 100%;
  max-width: 9.5rem;
}
.doc-status-buh__esf-row:not(.doc-status-buh__esf-row--with-ico) {
  display: grid;
  grid-template-columns: 1fr;
  justify-items: center;
}
.doc-status-buh__esf-row--with-ico {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 6px;
}
.doc-status-buh__esf-row--with-ico .doc-status-buh__esf-k {
  text-align: center;
  flex: 0 0 auto;
}
.doc-status-buh__chk {
  color: #43a047;
  flex-shrink: 0;
}
.doc-status-buh__esf-k {
  text-align: center;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.01em;
  color: rgba(0, 0, 0, 0.87);
  line-height: 1.35;
  min-width: 0;
}
.doc-status-buh__esf-k--ok {
  color: #2e7d32;
}
.doc-status-buh__esf-k--signed-miss {
  color: #e65100;
  font-weight: 500;
}
.doc-status-buh__divider {
  width: 100%;
  max-width: 9.5rem;
  height: 1px;
  margin: 5px 0 4px;
  background: #cfd8dc;
  border-radius: 1px;
}
.doc-status-buh__sign {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 9.5rem;
  gap: 6px;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.01em;
  color: rgba(0, 0, 0, 0.87);
}
.doc-status-buh__sign-txt {
  min-width: 0;
  text-align: center;
}
.doc-status-buh__sign--with-ico {
  justify-content: space-between;
}
.doc-status-buh__sign--with-ico .doc-status-buh__sign-txt {
  text-align: left;
  flex: 1 1 auto;
}
.doc-status-buh__sign--ok {
  color: #2e7d32;
}
.doc-status-buh__sign--ok .doc-status-buh__chk {
  color: #43a047;
}
.doc-status-plain-wrap {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 9.5rem;
  margin: 0 auto;
}
.doc-status-plain-wrap--signed {
  gap: 6px;
}
.doc-status-plain {
  font-size: 13px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.82);
}
.doc-status-plain--ok {
  color: #2e7d32;
}

/* Колонка «1С»: ЭСФ для типов, кроме бух. АВР (у бух. АВР ЭСФ в колонке «Статус») */
.doc-1c-esf {
  margin: 8px auto 0;
  max-width: 9.5rem;
}
.doc-1c-esf--row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
.doc-1c-esf__k {
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.01em;
  color: rgba(0, 0, 0, 0.87);
  line-height: 1.35;
  min-width: 0;
  text-align: center;
}
.doc-1c-esf__k--ok {
  color: #2e7d32;
}

.doc-download-actions {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 10px;
  min-width: 0;
  max-width: 168px;
  margin: 0 auto;
}

.doc-download-actions__download {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
}

.doc-download-actions__followup {
  font-weight: 600;
  letter-spacing: 0.01em;
  min-height: 36px;
}
</style>
